import React from 'react';
import './StatusBar.css';

const StatusBar = ({ isOffline, isUpdateAvailable, onUpdate }) => {
  if (!isOffline && !isUpdateAvailable) return null;

  return (
    <div className="status-bar">
      {isOffline && (
        <div className="status-item offline">
          <i className="fas fa-wifi" aria-hidden="true"></i>
          <span>Sin conexión - Navegando offline</span>
        </div>
      )}

      {isUpdateAvailable && (
        <div className="status-item update">
          <i className="fas fa-download" aria-hidden="true"></i>
          <span>Nueva versión disponible</span>
          <button
            onClick={onUpdate}
            className="update-btn"
            aria-label="Actualizar aplicación"
          >
            Actualizar
          </button>
        </div>
      )}
    </div>
  );
};

export default StatusBar;
